export default __webpack_public_path__ + "static/media/bg_chart_x_line.70842066a094112403e202b21bbdaff8.svg";